var Education = "教育領域";
var Enterprise = "企業";
var CompanyType = {
	"Company type": "公司類型",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "聯邦政府",
	"Government - State & local": "州和地方政府",
	"Non-profit": "非營利",
	"Self employed": "自由業",
	"Small-medium business": "中小企業",
	"Start-up": "新創公司",
	"Not applicable": "不適用"
};

export { Education, Enterprise, CompanyType as default };
